module.exports = __webpack_public_path__ + "static/media/WeatherIcons.0a218296.gif";